<script>
    export let width = "60%",icon=false;
  </script>
  <svg {width} class:icon x="0px" y="0px" viewBox="0 0 100 100" >
      <g transform="translate(0,-952.36218)">
          <path d="m 11,974.36215 c -1.6274195,0 -2.9999995,1.37258 -2.9999995,3 l 0,50.00005 c 0,1.6274 1.37258,3 2.9999995,3 l 78,0 c 1.62742,0 3,-1.3726 3,-3 l 0,-50.00005 c 0,-1.62742 -1.37258,-3 -3,-3 l -77.999999,0 z m 4.03125,4 69.9375,0 L 50,1010.6434 15.031251,978.36215 z M 12,980.98715 48.65625,1014.8309 a 2.0001999,2.0001999 0 0 0 2.6875,0 L 88,980.98715 l 0,45.37505 -75.999999,0 0,-45.37505 z"/>
      </g>
  </svg>
  
  <style>
      svg {
          fill: currentColor;
      }
  </style>
  
  
  